import React from 'react'

const Deleteicon = () => {
    return (
        <div>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16" cy="16" r="15.7" fill="#FAFBFD" stroke="#E0E0E0" stroke-width="0.6" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.0004 23.3999H11.6004C10.9376 23.3999 10.4004 22.8626 10.4004 22.1999V11.3999H21.2004V22.1999C21.2004 22.8626 20.6631 23.3999 20.0004 23.3999Z" stroke="#EF3826" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.9996 19.8V15" stroke="#EF3826" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M17.6002 19.8V15" stroke="#EF3826" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M8 11.4H23.6" stroke="#EF3826" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.5998 9H13.9998C13.3371 9 12.7998 9.53726 12.7998 10.2V11.4H18.7998V10.2C18.7998 9.53726 18.2625 9 17.5998 9Z" stroke="#EF3826" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

        </div>
    )
}

export default Deleteicon
